import {z} from 'zod';

import i18n from '@dms/i18n';

export const QuickPresetFormSchema = z.object({
  name: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
  prompt: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
});

export type QuickPresetFormValue = z.infer<typeof QuickPresetFormSchema>;
